import { render, staticRenderFns } from "./SuperadminCompany.vue?vue&type=template&id=43f51b76&scoped=true&"
import script from "./SuperadminCompany.vue?vue&type=script&lang=js&"
export * from "./SuperadminCompany.vue?vue&type=script&lang=js&"
import style0 from "./SuperadminCompany.vue?vue&type=style&index=0&id=43f51b76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f51b76",
  null
  
)

export default component.exports